const loopbackHosts = new Set(["localhost", "127.0.0.1", "[::1]"]);

export function readerDevOrigin(
  configuredOrigin: string | undefined,
  currentLocation: Pick<Location, "protocol" | "hostname">,
): string {
  const origin = new URL(
    configuredOrigin ?? `${currentLocation.protocol}//${currentLocation.hostname}:3002`,
  );
  if (
    loopbackHosts.has(origin.hostname)
    && loopbackHosts.has(currentLocation.hostname)
  ) {
    origin.hostname = currentLocation.hostname;
  }
  return origin.origin;
}

export function readerDevPreviewUrl(
  configuredOrigin: string | undefined,
  currentLocation: Pick<Location, "protocol" | "hostname">,
  ebookId: string,
): string {
  const url = new URL("/", readerDevOrigin(configuredOrigin, currentLocation));
  url.searchParams.set("ebookId", ebookId);
  return url.toString();
}
